import React, { Component } from 'react';

class Downloads extends Component {
  render() {
    return (
        <main role="main" class="container">
          <h1 class="mt-5">Downloads</h1>
          <p class="lead">Some resources to download.</p>
          <ul>
            <li><a href="/downloads/HappyCo-API-Swagger-Latest.html">Swagger documentation</a></li>
            <li><a href="/downloads/HappyCo-API-Swagger-Latest.json">Swagger json</a></li>
          </ul>
          <p>We provide ready-to-use clients in several common programming languages:</p>
          <ul>
              <li><a href="/downloads/go-simple-client.zip">Go client</a></li>
              <li><a href="/downloads/csharp-simple-client.zip">C# client</a></li>
              <li><a href="/downloads/python-simple-client.zip">Python client</a></li>
              <li><a href="/downloads/java-simple-client.zip">Java client</a> (<a href="/downloads/java-simple-client-source.zip">source</a>)</li>
          </ul>
          <p>You can use these clients as a starting point to build your own applications.</p>
          <p>Alternatively, if your programming language is not listed here you can also <a href="/downloads/proto.zip">download the protobuf files</a> to generate your own client. Refer to the <a href="https://grpc.io">gRPC documentation</a> for instructions.</p>
          <hr />
        </main>
    );
  }
}

export default Downloads;



// WEBPACK FOOTER //
// ./src/Downloads.js